export interface FindWorkRequestResult {
    FindWorkRequestResponse: FindWorkRequestResponse;
}

export interface CreateWorkRequestResult {
    CreateWorkRequestResponse: CreateWorkRequestResponse;
}

export interface FindWorkRequestResponse {
    BusinessObject: BusinessObject<WRHeaderList[] | WRHeaderList>;
    StandardReply: StandardReply;
}

export interface CreateWorkRequestResponse {
    BusinessObject: BusinessObject<WRHeaderCreate[] | WRHeaderCreate>;
    StandardReply: StandardReply;
}

export interface BusinessObject<T> {
    WRHeader: T;
}

export interface WRHeaderCommon {
    "@Type": string;
    WoReqNumber: number;
    WoReqStatus: string;
    WrTaskTitle: string;
    WrOrigLastName: string;
    Facility: string;
    WoTskPriority: string;

    WoReqNeedDate: string;
    WoReqNeedTime: string;

    WorkAgainstInd: string;
    JobType: string;
}

export interface WRHeaderCreate extends WRHeaderCommon {
    WoReqStatusDate: Date;
    WoReqStatusTime: string;
    WrOrigFirstInit: string;
    WoReqOrgDept: string;
    WoReqOriginator: string;
    JobActiveInd: string;
    Unit: string;
    EquipmentType: string;
    EquipmentNumber: number;
    EquipmentName: string;
    LocationDesc: string;
    TroubleBreakdown: string;
    ECode: string;
    OpSystem: number;
    Division: string;
    OutageInd: string;
}

export interface WRHeaderList extends WRHeaderCommon {
    WoReqDateEnter: string;
    WoReqTimeEnter: string;

    ScrollingParameters?: ScrollingParameters;
}

export interface ScrollingParameters {
    "@Type": string;
    ScrollingCmd?: string;
    TopPageKey?: number;
    BottomPageKey?: number;
    MoreDataAbove?: string;
    MoreDataBelow?: string;
}

export interface StandardReply {
    ReplyMessages: ReplyMessages;
}

export interface ReplyMessages {
    ReturnCode: number;
    ErrorMsgCount: number;
    WarningMsgCount: number;
    InfoMsgCount: number;
    MessageEntry: MessageEntry;
}

export interface MessageEntry {
    Type: string;
    Code: string;
    Text: string;
}

export type DpCodePriority = 'AL' | 'E1' | 'E2' | 'RA' | 'S1' | 'S2' | 'U1' | 'U2';

export const DPPriorities: Array<{ code: DpCodePriority, name: string }> = [
    { code: 'AL', name: 'A REALISER AVANT LE (DATE SUPERIEURE A LA SEMAINE)' },
    { code: 'E1', name: 'EXPLOITATION - DEMANDE AVEC IMPACT TRÈS IMMEDIAT' },
    { code: 'E2', name: 'EXPLOIT-DEMANDE AVEC IMPACT TRÈS DIFFERE+DATE ECHEANCE SOUHAI' },
    { code: 'RA', name: 'A REALISER SUR ARRET' },
    { code: 'S1', name: 'SECURITE - DEMANDE D\'INTERVENTION IMMEDIATE' },
    { code: 'S2', name: 'SECURITE -DEMANDE INTERV. DIFFEREE + DATE ECHEANCE SOUHAITEE' },
    { code: 'U1', name: 'SURETE - DEMANDE D\'INTERVENTION IMMEDIATE' },
    { code: 'U2', name: 'SURETE  DEMANDE D\'INTERV.DIFFEREE + DATE ECHEANCE SOUHAITEE' }
];

export type DpCodePrestationType = 'A1' | 'A2' | 'AM' | 'B1' | 'B2' | 'C1' | 'C2' | 'CS' | 'D1' | 'D2' | 'D5' | 'DE' |
    'ES' | 'ET' | 'F1' | 'FA' | 'FD' | 'G1' | 'G2' | 'I1' | 'I2' | 'K1' | 'K2' | 'L1' | 'L2' | 'M1' | 'MO' | 'N1' | 'N4' |
    'NP' | 'P3' | 'P4' | 'PG' | 'PM' | 'R1' | 'R2' | 'RE' | 'RP' | 'RU' | 'S1' | 'S2' | 'SU' | 'T1' | 'T2' | 'TD' | 'V1' |
    'V2' | 'W1' | 'W2' | 'Z1' | 'Z2';

export const DPPrestationTypes: Array<{ code: DpCodePrestationType, name: string }> = [
    { code: 'A1', name: 'INTERNE DE TYPE DI NON RADIOLOGIQUE' },
    { code: 'A2', name: 'INTERNE DE TYPE DI RADIOLOGIQUE' },
    { code: 'AM', name: 'AMÉLIORATION' },
    { code: 'B1', name: 'AMPA DE TYPE DI NON RADIOLOGIQUE' },
    { code: 'B2', name: 'AMPA DE TYPE DI RADIOLOGIQUE' },
    { code: 'C1', name: 'CORRECTIF DE TYPE DI NON RADIOLOGIQUE' },
    { code: 'C2', name: 'CORRECTIF DE TYPE DI RADIOLOGIQUE' },
    { code: 'CS', name: 'CONSULTATION' },
    { code: 'D1', name: 'DISCORDANCE DE TYPE DI NON RADIOLOGIQUE' },
    { code: 'D2', name: 'DISCORDANCE DE TYPE DI RADIOLOGIQUE' },
    { code: 'D5', name: 'DISCORDANCE TRAITEMENT AUTRE QUE PAR MAINTENANCE' },
    { code: 'DE', name: 'DOSSIER D\'ETUDE' },
    { code: 'ES', name: 'ECHANGE STANDARD (REMPLACEMENT EQUIPEMENT)' },
    { code: 'ET', name: 'ÉTALONNAGE' },
    { code: 'F1', name: 'FABRICATION DE TYPE DI' },
    { code: 'FA', name: 'FOURNITURES INDUSTRIELLES POUR MAFA' },
    { code: 'FD', name: 'FICHE DE TRAITEMENT DE DEFAUT EMBALLAGE' },
    { code: 'G1', name: 'PREPARATION DE TYPE DI NON RADIOLOGIQUE' },
    { code: 'G2', name: 'PREPARATION DE TYPE DI RADIOLOGIQUE' },
    { code: 'I1', name: 'INFORMATIQUE DE TYPE DI NON RADIOLOGIQUE' },
    { code: 'I2', name: 'INFORMATIQUE DE TYPE DI RADIOLOGIQUE' },
    { code: 'K1', name: 'DEMANDE SUITE A ALERTE KASEM NON RADIOLOGIQUE' },
    { code: 'K2', name: 'DEMANDE SUITE A ALERTE KASEM RADIOLOGIQUE' },
    { code: 'L1', name: 'LOGISTIQUE DE TYPE DI NON RADIOLOGIQUE' },
    { code: 'L2', name: 'LOGISTIQUE DE TYPE DI RADIOLOGIQUE' },
    { code: 'M1', name: 'METROLOGIE' },
    { code: 'MO', name: 'MODÈLE' },
    { code: 'N1', name: 'DIAGNOSTIQUE AMIANTE' },
    { code: 'N4', name: 'DECONTAMINATION' },
    { code: 'NP', name: 'TRAVAIL NON-PLANIFIÉ' },
    { code: 'P3', name: 'PREVENTIF OU NON CONFORMITE ASSOCIEE NON RADIOLOGIQUE' },
    { code: 'P4', name: 'PREVENTIF OU NON CONFORMITE ASSOCIEE RADIOLOGIQUE' },
    { code: 'PG', name: 'PRET DE GABARITS' },
    { code: 'PM', name: 'MAINTENANCE PRÉVENTIVE ET AUTRES PROGRAMMES' },
    { code: 'R1', name: 'REPARATION DE TYPE DI NON RADIOLOGIQUE' },
    { code: 'R2', name: 'REPARATION DE TYPE DI RADIOLOGIQUE' },
    { code: 'RE', name: 'APPRO. FAB. PREPA. PIECES DE RECHANGE OU OUTILLAGES' },
    { code: 'RP', name: 'RÉPARATION' },
    { code: 'RU', name: 'RÉCUPÉRATION' },
    { code: 'S1', name: 'SITE DE TYPE DI NON RADIOLOGIQUE' },
    { code: 'S2', name: 'SITE DE TYPE DI RADIOLOGIQUE' },
    { code: 'SU', name: 'SUPPLÉMENTAIRE' },
    { code: 'T1', name: 'TRANSPORT DE TYPE NON RADIOLOGIQUE' },
    { code: 'T2', name: 'TRANSPORT DE TYPE RADIOLOGIQUE' },
    { code: 'TD', name: 'TACHE DE DIAGNOSTIQUE' },
    { code: 'V1', name: 'NTQC NON RADIOLOGIQUE' },
    { code: 'V2', name: 'NTQC RADIOLOGIQUE' },
    { code: 'W1', name: 'TACHE DE VISITE ET VIEILLISSEMENT NON RADIOLOGIQUE' },
    { code: 'W2', name: 'TACHE DE VISITE ET VIEILLISSEMENT  RADIOLOGIQUE' },
    { code: 'Z1', name: 'CONTROLE INTERNE SUR CODE ARTICLE EN STOCK MAGASIN' },
    { code: 'Z2', name: 'RECETTE DE MATERIEL POUR MISE EN STOCK' }
];
